export default class ClassHandler {

}
